<template>
   <div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
            <!--SLIDE-1-->
            <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Actividad de conocimientos previos">
                <div class="container-fluid">
                    <div class="row" id="slide-1">
                        <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 pr-0 p-2 ">
                            <div class="p-3 pl-lg-5">
                                <h2 class="mt-5">Actividad de conocimientos previos</h2>
                                <h3>Teorías del desarrollo </h3>
                                <h5>Tipo de actividad: foro/tarea</h5>
                                <h4 class="mt-3 pt-xl-5 pt-lg-5 pt-3">Objetivo</h4>
                                <p>Identificar los conocimientos previos que presentan los estudiantes sobre las teorías del desarrollo.</p>
                                <h4 class="mt-3">¿Qué hacer?</h4>
                                <p>Participe en el foro virtual llamado <span class="font-italic">Desarrollo, cognición y lenguaje</span>, y responda las siguientes preguntas en un texto breve a modo de prosa.</p>
                                <p>Responda las preguntas que se plantean, de acuerdo a la lectura del siguiente artículo (búsquelo en la web y léalo):</p>
                                <p><span class="i-check color1Ppal mr-1 iconoMediano"></span>Castillo, R. y Castillo, J. (2003). El desarrollo del lenguaje total: análisis y perspectivas. <i>Islas</i> , pp. 113-124.</p>
                                <p>Según el artículo:</p>
                                <p class="mb-xl-5 mb-lg-5">
                                    <span class="color1Ppal mr-2">•</span>¿Qué relación existe entre el lenguaje y la inteligencia?<br>
                                    <span class="color1Ppal mr-2">•</span>¿Cómo se vinculan la educación, el desarrollo y el lenguaje?<br>
                                    <span class="color1Ppal mr-2">•</span>¿Qué retos plantea el aprendizaje para los niños y niñas?<br>
                                </p>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 offset-xl-1 offset-lg-1 Fondo-CP justify-content-center align-items-center"> 
                          
                            <p class="RefimgActiv">Foto de Markus Spiske en <a href="https://unsplash.com/photos/nvKQ1kxheRc" target="_blank" class="text-white">Unsplash</a></p>
                            <div class="w-100 pl-lg-3 pr-lg-3 pl-1 pr-1 pt-5 mt-lg-5 mb-5 pb-5">
                                <div class="row ml-xl-3 ml-lg-1 ml-0 mr-xl-3 mr-lg-1 mr-0 vh-xl-100">
                                    <div class="col-lg-12 col-md-12 col-12 p-lg-5 p-3 d-flex align-items-center justify-content-center">	
                                        <div class="row mt-3 cuadroGAVI ml-lg-4">                       
											<div class="col-lg-3 col-md-3 col-sm-12 col-12 align-items-center d-flex justify-content-center">
												<img src="recursos/img/GAVI/Ten_en_cuenta_que.png" alt="" class="img-fluid">
											</div>
											<div class="col-lg-9 col-md-9 col-sm-12 col-12">
												<p class="tal">Ten en cuenta que:</p>
												<p>Para completar de esta actividad debes responder las preguntas en un texto en el que tome evidencias del artículo y luego compartirlo en el foro temático <span class="font-italic">Desarrollo, cognición y lenguaje</span>.</p>
                                                <p>La socialización de las respuestas la haremos en un encuentro sincrónico.</p>
											</div>
                                            <div class="col-12">
                                                <button class="btn BtnPrincipal d-flex mx-auto" onClick="javascript:window.open('http://campusvirtual.itm.edu.co/mod/forum/view.php?id=204033', '_blank');">Ir al foro </button>
                                            </div>
										</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {SwiperController} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'ConocimientosPrevios',

    mounted(){
        SwiperController(),
        document.title = this.$route.meta.title
    }
}
</script>